import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './Award.module.scss';

class Award extends Component {
  static propTypes = {
    award: PropTypes.object.isRequired
  };

  render() {
    const {
      award: { description, image }
    } = this.props;

    return (
      <div className={styles.Award}>
        <div className={styles.TextBox}>
          <p
            className={styles.Paragraph}
            dangerouslySetInnerHTML={{
              __html: description
            }}
          />
        </div>
        <div className={styles.ImageBox}>
          <img
            className={styles.Image}
            src={OptimizeImagesService.adjustImageSize(image.url)}
            alt={image.description}
          />
        </div>
      </div>
    );
  }
}

export default Award;



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Awards/components/Award/Award.js